import Vue from 'vue'
import Router from 'vue-router'
// import Detail from '@/views/Detail'
// import Book from '@/views/Book'
// import CustomerAddress from '@/views/CustomerAddress'
// import EditCustomerAddress from '@/views/EditCustomerAddress'
// import OrderDetail from '@/views/OrderDetail'
// import Refundment from '@/views/Refundment'

Vue.use(Router)

function trimAppUrlHost() {
    let getApplicationUrl = typeof window !== 'undefined' ? window.app_url : undefined;
    if (getApplicationUrl) {
        return '/' + getApplicationUrl('').replace(/^http(s)?:\/\/.*?\//, '');
    } else {
        return '/'
    }
}
let baseUrl = trimAppUrlHost('');

const router = new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: baseUrl + 'item/:id(\\d+)/',
            name: 'Detail',
            component: () => import('@/views/Detail')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/discount',
            name: 'Discount',
            component: () => import('@/views/Discount')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/coupon',
            name: 'Coupon',
            component: () => import('@/views/Coupon')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/buy',
            name: 'Buy',
            component: () => import('@/views/Buy')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/customerAddress',
            name: 'CustomerAddress',
            component: () => import('@/views/CustomerAddress')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/editCustomerAddress',
            name: 'EditCustomerAddress',
            component: () => import('@/views/EditCustomerAddress')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/booknotice',
            name: 'BookNotice',
            component: () => import('@/views/BookNotice')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/bookCommon',
            name: 'BookCommon',
            component: () => import('@/views/BookCommon')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/bookNoticeMoc',
            name: 'BookNoticeMoc',
            component: () => import('@/views/bookNoticeMoc')
        },
        {
            path: baseUrl + 'item/tourContract',
            name: 'TourContract',
            component: () => import('@/views/TourContract')
        },
        {
            path: baseUrl + 'item/tourContractIframe',
            name: 'TourContractIframe',
            component: () => import('@/views/TourContractIframe')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/booknotips',
            name: 'BookTips',
            component: () => import('@/views/BookTips')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/notice',
            name: 'Notice',
            component: () => import('@/views/Notice')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/policy',
            name: 'Policy',
            component: () => import('@/views/Policy')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/comment',
            name: 'Comment',
            component: () => import('@/views/Comment')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/journey',
            name: 'Journey',
            component: () => import('@/views/Journey')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/package',
            name: 'Package',
            component: () => import('@/views/Package')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/book',
            name: 'Book',
            component: () => import('@/views/Book')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/invoice',
            name: 'Invoice',
            component: () => import('@/views/Invoice')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/city',
            name: 'City',
            component: () => import('@/views/City')
        },
        {
            path: baseUrl + 'cdkey',
            name: 'Cdkey',
            component: () => import('@/views/Cdkey')
        },
        {
            path: baseUrl + 'item/:id(\\d+)/back',
            name: 'Back',
            component: () => import('@/views/Back')
        }
    ]
});

export default router;



// WEBPACK FOOTER //
// libs/router/index.js